import { render } from "./enclosure.vue?vue&type=template&id=390ab518"
import script from "./enclosure.vue?vue&type=script&lang=js"
export * from "./enclosure.vue?vue&type=script&lang=js"

import "./enclosure.vue?vue&type=style&index=0&id=390ab518&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__